import { alertActions, userActions } from './';
import { authHeader, handleJSONResponse, store, history } from '../helpers';

// Inner Helpers
const checkJSONRequest = (response) => {
  const dispatch = store.dispatch;
  return handleJSONResponse(response, (data, code) => {
    if (code === 401) dispatch(userActions.logout());
    if (code !== 401) history.push('/error?code=403');
  });
};

export const CLIENTS_FETCHONE_SUCCESS = 'CLIENTS_FETCHONE_SUCCESS';
export const CLIENTS_GETALL_REQUEST = 'CLIENTS_GETALL_REQUEST';
export const CLIENTS_GETALL_SUCCESS = 'CLIENTS_GETALL_SUCCESS';
export const CLIENTS_GETALL_FAILURE = 'CLIENTS_GETALL_FAILURE';
export const CLIENTS_CREATEONE_SUCCESS = 'CLIENTS_CREATEONE_SUCCESS';
export const CLIENTS_UPDATEONE_SUCCESS = 'CLIENTS_UPDATEONE_SUCCESS';

export const clientsActions = {
  fetchOne,
  createItem,
  updateItem,
  getClients: getAll,
  getLibrary,
  // delete: _delete
};

function fetchOne(id) {
  return (dispatch) => {
    fetch(`${process.env.REACT_APP_API_URL}/clients/${id}`, {
      method: 'GET',
      headers: authHeader(),
    })
      .then(checkJSONRequest)
      .then((data) => dispatch(success(data[0] || null)));
  };
  // function request() { return { type: usersConstants.GETALL_REQUEST } }
  function success(item) {
    return { type: CLIENTS_FETCHONE_SUCCESS, item };
  }
  // function failure(error) { return { type: usersConstants.GETALL_FAILURE, error } }
}

function createItem(item) {
  return (dispatch) => {
    fetch(`${process.env.REACT_APP_API_URL}/clients`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(item),
    })
      .then(checkJSONRequest)
      .then((data) => dispatch(success(data || null)));
  };
  // function request() { return { type: usersConstants.GETALL_REQUEST } }
  function success(item) {
    return { type: CLIENTS_CREATEONE_SUCCESS, item: item };
  }
  // function failure(error) { return { type: usersConstants.GETALL_FAILURE, error } }
}

function updateItem(item) {
  return (dispatch) => {
    fetch(`${process.env.REACT_APP_API_URL}/clients/${item._id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(item),
    })
      .then(checkJSONRequest)
      .then((data) => {
        dispatch(success(data || null));
        dispatch(alertActions.success('Client data updated!'));
        setTimeout(() => dispatch(alertActions.clear()), 3000);
      });
  };
  // function request() { return { type: usersConstants.GETALL_REQUEST } }
  function success(item) {
    return { type: CLIENTS_UPDATEONE_SUCCESS, item: item };
  }
  // function failure(error) { return { type: usersConstants.GETALL_FAILURE, error } }
}

function getAll(filters = {}) {
  return (dispatch) => {
    dispatch(request());

    const qstring = Object.keys(filters)
      .filter((key) => !isNaN(filters[key]) || filters[key].length > 0)
      .map((key) => `${key}=${filters[key]}`)
      .join('&');

    fetch(
      `${process.env.REACT_APP_API_URL}/clients/all${
        qstring ? '?' + qstring : ''
      }`,
      {
        method: 'GET',
        headers: authHeader(),
      }
    )
      .then(checkJSONRequest)
      .then(
        (items) => dispatch(success(items)),
        (error) => dispatch(failure(error))
      );
  };

  function request() {
    return { type: CLIENTS_GETALL_REQUEST };
  }
  function success(items) {
    return { type: CLIENTS_GETALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: CLIENTS_GETALL_FAILURE, error };
  }
}

function getLibrary(id = '', filters = {}) {
  return (dispatch) => {
    dispatch(request());

    const qstring = Object.keys(filters)
      .filter((key) => !isNaN(filters[key]) || filters[key].length > 0)
      .map((key) => `${key}=${filters[key]}`)
      .join('&');

    fetch(
      `${process.env.REACT_APP_API_URL}/public/clients/${id}${
        qstring ? '?' + qstring : ''
      }`
    )
      .then(checkJSONRequest)
      .then(
        (items) => dispatch(success(items)),
        (error) => dispatch(failure(error))
      );
  };

  function request() {
    return { type: CLIENTS_GETALL_REQUEST };
  }
  function success(items) {
    return { type: CLIENTS_GETALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: CLIENTS_GETALL_FAILURE, error };
  }
}
